import React, {Component} from 'react';
import {connect} from 'react-redux';
import nl2br from 'react-nl2br';
import {fetchSystemMaintenanceNotice} from '../../actions/systemMaintenance.actions';
import {formatDateToYYYYMMDDhhmmss} from '../../util/timeUtils';
import './systemMaintenance.scss';

const stateToProps = state => {
  return {
    systemMaintenanceNotice: state.systemMaintenanceNotice,
  };
};

class SystemMaintenance extends Component {
  componentDidMount() {
    this.props.dispatch(fetchSystemMaintenanceNotice());
  }

  render() {
    let {systemMaintenanceNotice} = this.props;

    return (
      <div id="container" className="system-maintenance-notice">
        <div
          className="check_b"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-225px',
            marginLeft: '-400px',
          }}
        >
          <div className="check_txt_img">
            <img src="/image/systemMaintenance/system_maintenance_img01.gif" />
          </div>
          <div className="check_txt_list">
            <div className="check_list_con">
              <div className="img">
                <img src="/image/systemMaintenance/system_maintenance_img02.gif" width={82} height={71} />
              </div>
              <p>{systemMaintenanceNotice.title}</p>
              <p>&nbsp;</p>
              <p className="txt_light">
                {formatDateToYYYYMMDDhhmmss(systemMaintenanceNotice.start)} -{' '}
                {formatDateToYYYYMMDDhhmmss(systemMaintenanceNotice.end)}
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>점검범위</strong>
              </p>
              <p>&nbsp;</p>
              <p className="txt_light">{systemMaintenanceNotice.checkArea}</p>
              <p>&nbsp;</p>
              <p>
                <strong>서버점검현황</strong>
              </p>
              <p>&nbsp;</p>
              <p className="txt_light">{nl2br(systemMaintenanceNotice.content)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(stateToProps)(SystemMaintenance);
